"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function registerSource(type, source, manager) {
    var registry = manager.getRegistry();
    var sourceId = registry.addSource(type, source);
    function unregisterSource() {
        registry.removeSource(sourceId);
    }
    return {
        handlerId: sourceId,
        unregister: unregisterSource,
    };
}
exports.default = registerSource;
//# sourceMappingURL=registerSource.js.map


//////////////////
// WEBPACK FOOTER
// ./~/react-dnd/lib/registerSource.js
// module id = 2528
// module chunks = 0